import { getCustomerProfile } from '_models/redux/customer-profile/action';
import { connect } from 'react-redux';
import { ContainerModulesHook } from '../hooks/containerModulesHook';
import CardOffers from './CardOffer';

const ContainerModules = (props) => {
  const { services, unitTypeService } = ContainerModulesHook(props);
  return <CardOffers services={services} typeService={unitTypeService} />;
};

const mapStateToProps = (state) => ({
  customerProfile: state.customerProfile,
});
const mapDispatchToProps = { getCustomerProfile };

export default connect(mapStateToProps, mapDispatchToProps)(ContainerModules);
